import Style from './index.module.less'
import classNames from 'classnames'
import React from 'react'
import { Region_List_Treasure, type RegionDetailData } from '@/api/region/types'
import { useTranslation } from 'react-i18next'
import MeToolTip from '@/components/MeToolTip'
import {
  ansToGAG,
  formatValue,
  geaStrToGea,
  removeTrailingZeros,
  ugagToGag,
  ugeaToGea2,
} from '@/utils/number'
import { useParams } from 'react-router-dom'
const BlockCard = ({
  style = {},
  regionDetail = null,
  geaTotal = {
    value: '-',
    sigin: '',
  },
}: {
  style?: React.CSSProperties
  regionDetail: RegionDetailData | null
  geaTotal: {
    value: string
    sigin: string
  } | null
}) => {
  const { t } = useTranslation()
  const params = useParams()

  const getTreasureAmount = (val: Region_List_Treasure[], denom: 'ugag' | 'ugea') => {
    if (!val?.length) return ''
    if (denom === 'ugag') {
      return val.find((item) => item.denom === 'ugag')?.amount
    }
    return val.find((item) => item.denom === 'ugea')?.amount
  }

  return (
    <div style={{ ...style }} className={Style.wrap}>
      {params.dynamic === 'global_village' ? null : (
        <>
          <>
            <div className={Style.item}>
              {/* 质押上限 */}
              <span>{t('explorer_58')}：</span>
              <div
                className={classNames({
                  [Style.textStyleOne]: true,
                  font_14: true,
                })}
              >
                {/* {geaStrToGea(regionDetail?.totalMaxStake).value}{' '} */}
                1,346,720,000
                <span className={Style.textStyleThree}>
                  {/* {geaStrToGea(regionDetail?.totalMaxStake).sigin} */}
                  GEA
                </span>
              </div>
            </div>
          </>
        </>
      )}
      {/* 质押总量 */}
      {/* <div className={Style.item}>
        <span>
          <MeToolTip title={`${t('explorer_55')}：`} tip={t('explorer_127')}></MeToolTip>
        </span>
        <div className={Style.textStyleOne}>
          {ugeaToGea2(regionDetail?.totalStakeUgea).value}{' '}
          <span className={Style.textStyleThree}>
            {ugeaToGea2(regionDetail?.totalStakeUgea).sigin}
          </span>
        </div>
      </div> */}
      {/* 区金库 */}
      <div className={Style.item}>
        <span>
          <MeToolTip title={`${t('explorer_303')} :`} tip={t('explorer_305')}></MeToolTip>
        </span>
        <div className={Style.specialLine}>
          <div
            className={classNames({
              [Style.textStyleOne]: true,
              font_14: true,
            })}
          >
            {ugeaToGea2(getTreasureAmount(regionDetail?.treasure || [], 'ugea')).value}{' '}
            <span
              className={classNames({
                [Style.textStyleThree]: true,
                font_14: true,
              })}
            >
              {ugeaToGea2(getTreasureAmount(regionDetail?.treasure || [], 'ugea')).sigin}
            </span>
          </div>
          <div
            className={classNames({
              [Style.textStyleOne]: true,
              font_14: true,
            })}
          >
            {ugagToGag(getTreasureAmount(regionDetail?.treasure || [], 'ugag')).value}{' '}
            <span
              className={classNames({
                [Style.textStyleThree]: true,
                font_14: true,
              })}
            >
              {ugagToGag(getTreasureAmount(regionDetail?.treasure || [], 'ugag')).sigin}
            </span>
          </div>
        </div>
      </div>
      {/* <div className={Style.item}>
        <span>
          <MeToolTip title={`${t('explorer_303')} :`} tip={t('explorer_303_desc2')}></MeToolTip>
        </span>
        <div className={Style.textStyleOne}>
          {ugagToGag(getTreasureAmount(regionDetail?.treasure || [], 'ugag')).value}{' '}
          <span className={Style.textStyleThree}>
            {ugagToGag(getTreasureAmount(regionDetail?.treasure || [], 'ugag')).sigin}
          </span>
        </div>
      </div> */}
      {/* AGR质押总量 */}
      <div className={Style.item}>
        <span>
          <MeToolTip title={`${t('explorer_299')} :`} tip={t('explorer_299_desc')}></MeToolTip>
        </span>
        <div
          className={classNames({
            [Style.textStyleOne]: true,
            font_14: true,
          })}
        >
          <span>{ugeaToGea2(regionDetail?.currentKycTotalUgea).value}</span>
          <span
            className={classNames({
              [Style.textStyleThree]: true,
              font_14: true,
            })}
          >
            {ugeaToGea2(regionDetail?.currentKycTotalUgea).sigin}
          </span>
        </div>
      </div>
      {/* AGE质押 总量 灵活锁仓*/}
      <div className={Style.item}>
        <span>
          <MeToolTip title={`${t('explorer_300')} :`} tip={t('explorer_300_desc')}></MeToolTip>
        </span>
        <div
          className={classNames({
            [Style.textStyleOne]: true,
            font_14: true,
          })}
        >
          <span>{ugeaToGea2(regionDetail?.currentLockUpTotalUgea).value}</span>
          <span
            className={classNames({
              [Style.textStyleThree]: true,
              font_14: true,
            })}
          >
            {ugeaToGea2(regionDetail?.currentLockUpTotalUgea).sigin}
          </span>
        </div>
      </div>
      {/* AGD质押 总量 灵活锁仓*/}
      <div className={Style.item}>
        <span>
          <MeToolTip title={`${t('explorer_301')} :`} tip={t('explorer_301_desc')}></MeToolTip>
        </span>
        <div
          className={classNames({
            [Style.textStyleOne]: true,
            font_14: true,
          })}
        >
          <span>{ugeaToGea2(regionDetail?.currentNormalDelegationTotalUgea).value}</span>
          <span
            className={classNames({
              [Style.textStyleThree]: true,
              font_14: true,
            })}
          >
            {ugeaToGea2(regionDetail?.currentNormalDelegationTotalUgea).sigin}
          </span>
        </div>
      </div>
      {/* AGS质押 总量 灵活锁仓*/}
      <div className={Style.item}>
        <span>
          <MeToolTip title={`${t('explorer_302')} :`} tip={t('explorer_302_desc')}></MeToolTip>
        </span>
        <div
          className={classNames({
            [Style.textStyleOne]: true,
            font_14: true,
          })}
        >
          <span>{ugeaToGea2(regionDetail?.currentFixedDelegationTotalUgea).value}</span>
          <span
            className={classNames({
              [Style.textStyleThree]: true,
              font_14: true,
            })}
          >
            {ugeaToGea2(regionDetail?.currentFixedDelegationTotalUgea).sigin}
          </span>
        </div>
      </div>
      {/* GEA 总量，即总流通量字段 */}
      {/* <div className={Style.item}>
        <span>{t('explorer_264')}：</span>
        <div className={Style.textStyleOne}>
          <span>{geaTotal?.value}</span>
          <span className={Style.textStyleThree}>{geaTotal?.sigin}</span>
        </div>
      </div> */}
      {/* ANS 总量 */}
      {/* <div className={Style.item}>
        <span>{t('explorer_50')}：</span>
        <div className={Style.textStyleOne}>
          {formatValue(removeTrailingZeros(regionDetail?.totalAns, 8), true)}
        </div>
      </div> */}
      {/* GAG 总量 */}
      {/* <div className={Style.item}>
        <span>{t('explorer_49')}：</span>
        <div className={Style.textStyleOne}>{ansToGAG(regionDetail?.totalAns, false)}</div>
      </div> */}
      <div className={Style.item}>
        {/* 状态 */}
        <span>{t('explorer_53')} :</span>
        <div className={Style.statusWrap}>
          <span
            className={classNames({
              [Style.status]: true,
              [Style.normal]: true,
            })}
          >
            {/* 正常 */}
            {t('explorer_57')}
          </span>
        </div>
      </div>
    </div>
  )
}

export default BlockCard
